import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 15"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M13.47 1.012c.26.26.26.68 0 .94L9.605 5.818H12a.665.665 0 1 1 0 1.33H7.998a.663.663 0 0 1-.663-.665v-4a.665.665 0 1 1 1.33 0v2.395l3.865-3.865c.26-.26.68-.26.94 0ZM.602 13.987a.665.665 0 0 0 .94-.011l3.82-3.91.028 2.394a.665.665 0 1 0 1.33-.016l-.048-4a.663.663 0 0 0-.685-.656L2 7.835a.665.665 0 1 0 .016 1.33l2.394-.028-3.819 3.91a.665.665 0 0 0 .011.94Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }